//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Section.js";
import "../no/Section.js";
let d=[[[0,"LocatedPoint",1,"Point",0],[1,"PartPosition",0,"Section",0]],[[[],"GetAttributeData",{R_:{conceptRecord:"Tooling.ConceptStandardPartRecord"}},0,0],[["conceptRecord"],"SetAttributeData",{},1,0],[["numPoints","selectedPoints"],"GetSelectedPoints",{},0,0],[["point"],"AddToSelectedPoints",{},1,0],[["attachPoint"],"InsertSymbol",{},1,0],[["sketch","numPoints"],"AddLinkFeature",{R_:{createdPoints:"Point[]"}},1,0],[[],"Clear",{},0,0]],[]];
SPLM.Tooling.ConceptPositionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ConceptPositionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;